import { useEffect } from "react";
import qs from "qs";
import { useHistory, useLocation } from "react-router";
import { useSelector } from "react-redux";

import { getLoginWithRedirectUrl } from "../../../../../lib/auth/authRedirectUrl";
import {
  CREATE_PRICE_ALERT_INTENT_TYPE,
  resolveCreatePriceAlertIntent,
  stripCreatePriceAlertParams
} from "../../../../../lib/priceAlerts/createPriceAlertQuery";
import { showModal } from "../../../../../lib/react-redux-modal-provider";
import {
  getLoginLoading,
  getUserData
} from "../../../../../redux/modules/auth/login/selector";
import { getAuthLoginLoading } from "../../../../../redux/modules/authLoginLoading/selector";
import {
  getHasPermission,
  PLAN_PERMISSIONS_SECTIONS
} from "../../../../../redux/modules/auth/userPermissions/selector";
import { getInitialAuthCheckPending } from "../../../../../redux/modules/initialAuthCheck/selector";
import { getLocale } from "../../../../../redux/modules/translations/selector";

function replaceSearch(history, pathname, searchParams) {
  const nextSearch = qs.stringify(searchParams, { addQueryPrefix: true });

  history.replace({
    pathname,
    search: nextSearch || ""
  });
}

function CreatePriceAlertProvider() {
  const history = useHistory();
  const location = useLocation();
  const locale = useSelector(getLocale);
  const userData = useSelector(getUserData);
  const loginLoading = useSelector(getLoginLoading);
  const authLoginLoading = useSelector(getAuthLoginLoading);
  const initialAuthCheckPending = useSelector(getInitialAuthCheckPending);
  const hasPermission = useSelector(getHasPermission);
  const isAuthPending =
    loginLoading || authLoginLoading || initialAuthCheckPending;

  useEffect(() => {
    const intent = resolveCreatePriceAlertIntent({
      search: location.search
    });

    if (!intent) {
      return;
    }

    if (intent.type === CREATE_PRICE_ALERT_INTENT_TYPE.INVALID) {
      replaceSearch(
        history,
        location.pathname,
        stripCreatePriceAlertParams(intent.searchParams)
      );
      return;
    }

    if (isAuthPending) {
      return;
    }

    const clearCreatePriceAlertParams = () => {
      replaceSearch(
        history,
        location.pathname,
        stripCreatePriceAlertParams(intent.searchParams)
      );
    };

    if (!userData) {
      const returnUrl = `${location.pathname}${location.search}`;
      const loginUrl = getLoginWithRedirectUrl({
        locale,
        returnUrl
      });

      history.push(loginUrl);
      return;
    }

    clearCreatePriceAlertParams();

    if (!hasPermission(PLAN_PERMISSIONS_SECTIONS.PRICE_ALERTS)) {
      showModal("PremiumModal", {
        permissions: PLAN_PERMISSIONS_SECTIONS.PRICE_ALERTS
      });
      return;
    }

    showModal("NewPriceAlertsModal", {
      stockId: intent.stockId,
      price: intent.price,
      description: intent.comment
    });
  }, [
    hasPermission,
    history,
    isAuthPending,
    location.pathname,
    location.search,
    locale,
    userData
  ]);

  return null;
}

export default CreatePriceAlertProvider;
